// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1___ed7de51238858de78af","cls2":"SuggestionCard-cls2__ad0e3caa425d19c26715 SuggestionCard-cls1___ed7de51238858de78af"};